import axios from 'axios';

export const login = () => {
  if (typeof window !== 'undefined') {
    window.location.href = `${process.env.GATSBY_SIGN_IN}?rd=${window.location.href}`;
  }
};

// Silencieux : ne redirige jamais vers le login, utilisé pour sonder la session au chargement.
export const getUserInfo = async () => {
  try {
    return await axios.get(process.env.GATSBY_USER_INFO, {
      withCredentials: true,
    });
  } catch (_error) {
    return null;
  }
};

// Dérive des initiales à afficher depuis preferredUsername/email (ex. "jean.dupont@..." -> "JD") :
// le userinfo d'oauth2-proxy n'expose pas de firstName/lastName.
export const getInitials = (userInfo) => {
  const identifier = userInfo?.preferredUsername || userInfo?.email || '';
  return identifier
    .split('@')[0]
    .split('.')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
};

export const userLogout = () => {
  if (typeof window !== 'undefined') {
    window.location.href = `${process.env.GATSBY_SIGN_OUT}?rd=${window.location.href}`;
  }
};

export const hasRoles = async (roles) => {
  const result = await getUserInfo();
  let hasRoles = false;

  const userRoles = result?.data?.groups?.map((role) => role.toLowerCase());
  if (userRoles) {
    roles?.forEach((role) => {
      if (userRoles.indexOf(role.toLowerCase()) !== -1) {
        hasRoles = true;
        return false;
      }
    });
  } else {
    hasRoles = false;
  }
  return hasRoles;
};
